import { http, HttpResponse } from 'msw';
import { picklistFactory } from '@trukt/factories/picklistFactory';
import { mockTruktTmsApiUrl } from '../mocks';
import { PicklistGetResponse } from '../services/PicklistService';

export const handlers = [
  http.get(mockTruktTmsApiUrl('/picklist/options'), () => {
    return HttpResponse.json<PicklistGetResponse>(picklistFactory.build());
  }),
];
